
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/tops",
      function () {
        return require("private-next-pages/apparel/tops/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/tops"])
      });
    }
  